<template src="./TarjetasOrdenes.html"></template>

<script>
import DatePicker from "../DatePicker/Datepicker"
export default {
    data() {
        return {
            show: false,
            date: new Date().toISOString().substr(0, 10),
            options: {
                locale: "es",
                format: "YYYY/MM/DD",
                clearable: true
            },
            // elemento:[
            //     {
            //         "key": "zd818e291a",
            //         "valor": "S8903055",
            //         "variable": "variable14",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Cups",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": false
            //     },
            //     {
            //         "nombre": "Prestación",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z8332cb0ea",
            //         "valor": "Seguimiento programa respiratorio",
            //         "variable": "variable13",
            //         "visible": true,
            //         "lista": "procedimientos_ordenes",
            //         "opciones_lista": [
            //             {
            //                 "valor": "Espirometría y curva flujo pre y post broncodilatadores",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Espirometría y curva simple",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Prueba de caminata de 6 minutos",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Curva flujo volumen pre y post broncodilatadores",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Saturación percutánea",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Prueba de broncomotricidad con ejercicio y monitoreo",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Oximetría nocturna",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Poligrafía respiratoria",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Rehabilitación pulmonar",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Polisomnografía basal con oximetría",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Polisomnograma en titulación CPAP nasal",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Prueba de latencia múltiple del sueño",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Programa de rehabilitación de tabaquismo",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Evaluación neumología asistida",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta médico general no programada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Nutrición",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Psicología",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Curva de flujo volumen simple",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta de ingreso",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Actividad educativa IPS",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta médica especializada II",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta neumólogo",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta neumólogo pediatra",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Control neumólogo",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Seguimiento programa respiratorio",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Poligrafía respiratoria para titulación",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Llamada cita de ingreso",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Seguimiento programa tabaquismo",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Seguimiento rehabilitación",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Polisomnografía basal con oximetría noche partida",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Auto CPAP",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "BPAP",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Servoventilador",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Consulta de ingreso sueño",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Llamada ingreso sueño",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Implementación CPAP ",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
            //      {
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "za01724f9a",
            //         "valor": "factura",
            //         "variable": "variable11",
            //         "visible": true,
            //         "lista": "Estado ordenes",
            //         "nombre": "Estado",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "opciones_lista": [
            //             {
            //                 "valor": "creada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "generada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "externa",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "no autorizada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "autorizada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "asignada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "factura",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "procesada",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "no_afecte",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "revisada"
            //             },
            //             {
            //                 "valor": "pendiente",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
                
            //     {
            //         "nombre": "Número orden",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z3b598ed3a",
            //         "valor": "Numero prueba",
            //         "variable": "variable1",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "nombre": "Tipo identificación",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z03a86d4ea",
            //         "valor": "Cc",
            //         "variable": "variable2",
            //         "visible": true,
            //         "lista": "Tipo de documento",
            //         "opciones_lista": [
            //             {
            //                 "valor": "CC",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "CE",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "PA",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "RC",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "TI",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
            //     {
            //         "grafica": null,
            //         "key": "zb329dc44a",
            //         "valor": 123123123,
            //         "variable": "variable3",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Documento",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "numero",
            //         "lim_superior": null
            //     },
            //     {
            //         "nombre": "Nombre",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "zb897291da",
            //         "valor": "John Stiben",
            //         "variable": "variable4",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "valor": "Perez Brand",
            //         "variable": "variable5",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Apellido",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z02ee75efa"
            //     },
            //     {
            //         "nombre": "Teléfono",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "numero",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z57eb500ea",
            //         "valor": "3505787553",
            //         "variable": "variable6",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z27df691ea",
            //         "valor": null,
            //         "variable": "variable7",
            //         "visible": false,
            //         "lista": null,
            //         "nombre": "Tipo estado"
            //     },
            //     {
            //         "grafica": null,
            //         "key": "z110d6819a",
            //         "valor": null,
            //         "variable": "variable8",
            //         "visible": true,
            //         "lista": "proveedores_ordenes",
            //         "nombre": "Proveedor",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "opciones_lista": [
            //             {
            //                 "valor": "EPS Sura",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Seguros suramericana",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Medplus",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Particular",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
            //     {
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "zabc2b9bba",
            //         "valor": null,
            //         "variable": "variable9",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Tipo pago paciente",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true
            //     },
            //     {
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z1fa5262aa",
            //         "valor": null,
            //         "variable": "variable10",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Tipo pago orden",
            //         "lim_inferior": null,
            //         "limites": null
            //     },
               
            //     {
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z83f2bb3fa",
            //         "valor": "si",
            //         "variable": "variable12",
            //         "visible": true,
            //         "lista": "si_no",
            //         "nombre": "Agendable",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "opciones_lista": [
            //             {
            //                 "valor": "Sí",
            //                 "puntaje": null,
            //                 "icono": ""
            //             },
            //             {
            //                 "valor": "No",
            //                 "puntaje": null,
            //                 "icono": ""
            //             }
            //         ]
            //     },

            //     {
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z93ea20cca",
            //         "valor": "copago",
            //         "variable": "variable15",
            //         "visible": true,
            //         "lista": "Categoria pago",
            //         "nombre": "Categoría pago",
            //         "opciones_lista": [
            //             {
            //                 "valor": "Copago",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Cuota moderadora",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Exento",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
            //     {
            //         "nombre": "Nivel de precio",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z93a62d1da",
            //         "valor": null,
            //         "variable": "variable16",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "grafica": false,
            //         "key": "ze30df0e4a",
            //         "valor": 0,
            //         "variable": "variable17",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Valor cancelado",
            //         "lim_inferior": null,
            //         "limites": false,
            //         "obligatorio": true,
            //         "tipo": "numero",
            //         "lim_superior": null
            //     },
            //     {
            //         "nombre": "Valor prestación",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "numero",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "zcca2570ba",
            //         "valor": 0,
            //         "variable": "variable18",
            //         "visible": false,
            //         "lista": null
            //     },
            //     {
            //         "nombre": "Prioridad",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z290385e6a",
            //         "valor": "Baja",
            //         "variable": "variable19",
            //         "visible": false,
            //         "lista": null
            //     },
            //     {
            //         "grafica": null,
            //         "key": "zfe88dc9da",
            //         "valor": true,
            //         "variable": "variable20",
            //         "visible": false,
            //         "lista": null,
            //         "nombre": "Interna",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null
            //     },
            //     {
            //         "nombre": "Sede",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "lista",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z9bc947eba",
            //         "valor": null,
            //         "variable": "variable21",
            //         "visible": true,
            //         "lista": "Sedes",
            //         "opciones_lista": [
            //             {
            //                 "valor": "Medellin",
            //                 "puntaje": null
            //             },
            //             {
            //                 "valor": "Rionegro",
            //                 "puntaje": null
            //             }
            //         ]
            //     },
            //     {
            //         "grafica": null,
            //         "key": "za983298ba",
            //         "valor": null,
            //         "variable": "variable22",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Indicaciones",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null
            //     },
            //     {
            //         "grafica": null,
            //         "key": "zfe8e00b0a",
            //         "valor": null,
            //         "variable": "variable23",
            //         "visible": false,
            //         "lista": null,
            //         "nombre": "Usuario",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null
            //     },
            //     {
            //         "key": "zd3696d20a",
            //         "valor": null,
            //         "variable": "variable24",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Fecha autorización",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "fecha",
            //         "lim_superior": null,
            //         "grafica": null
            //     },
            //     {
            //         "nombre": "Fecha activación",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "fecha",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z1286f489a",
            //         "valor": 1571155557749,
            //         "variable": "variable25",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "nombre": "Fecha vencimiento",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "fecha",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "za30493b0a",
            //         "valor": null,
            //         "variable": "variable26",
            //         "visible": true,
            //         "lista": null
            //     },
            //     {
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Fecha posible respuesta",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "fecha",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z3d874dc9a",
            //         "valor": null,
            //         "variable": "variable27"
            //     },
            //     {
            //         "key": "ze7bd6f7da",
            //         "valor": null,
            //         "variable": "variable28",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Fecha atención",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null
            //     },
            //     {
            //         "valor": 'asdfghjkl',
            //         "variable": "variable29",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Código diagnostico primario",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z699c1087a"
            //     },
            //     {
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": true,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "z8a204dcba",
            //         "valor": null,
            //         "variable": "variable30",
            //         "visible": false,
            //         "lista": null,
            //         "nombre": "Número solicitud"
            //     },
            //     {
            //         "valor": null,
            //         "variable": "variable31",
            //         "visible": true,
            //         "lista": null,
            //         "nombre": "Descripción",
            //         "lim_inferior": null,
            //         "limites": null,
            //         "obligatorio": false,
            //         "tipo": "string",
            //         "lim_superior": null,
            //         "grafica": null,
            //         "key": "zbbbc63fea"
            //     },
            //     {
            //         "lim_superior": null,
            //         "tipo": "string",
            //         "key": "ze99f793ca",
            //         "nombre": "Palabra clave",
            //         "variable": "variable32",
            //         "lim_inferior": null,
            //         "valor": "Seguimiento prog.resp ",
            //         "limites": null,
            //         "obligatorio": true,
            //         "lista": null,
            //         "visible": false
            //     },
            //     {
            //         "obligatorio": true,
            //         "lista": null,
            //         "visible": false,
            //         "tipo": "string",
            //         "key": "z189z6ydaa",
            //         "limite_inferior": null,
            //         "nombre": "Tipo de orden",
            //         "limite_superior": null,
            //         "variable": "variable33",
            //         "valor": "seguimiento",
            //         "limites": null
            //     },
            //     {
            //         "lista": null,
            //         "visible": false,
            //         "tipo": "string",
            //         "key": "zo99z65daa",
            //         "limite_inferior": null,
            //         "nombre": "Evento",
            //         "limite_superior": null,
            //         "variable": "variable34",
            //         "valor": "seguimiento_programa_respiratorio",
            //         "limites": null,
            //         "obligatorio": "true"
            //     }
            // ]
        }
    },
    props:{
        elemento:{
            type: Object
        }
    },
    components: {
        DatePicker,
    },
}
</script>

<style lang="scss" scoped src='./TarjetasOrdenes.scss'></style>


// WEBPACK FOOTER //
// src/components/TarjetasOrdenes/TarjetasOrdenes.vue